export const EsrDashboardTemp = {
    getFormName() {
        return {
            quarter:'',   
            
            Financials: [
                {
                   
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
            ],

            Sales: [
               
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
               
            ],

            Critical_Dates: [
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
                {
                    key_matrics: '',
                    goal: '',
                    goal_per: '',
                    forecast: '',
                    forecast_per: '',
                    status: '',
                    comment: '',
                },
            ],

            SI_Project: [
                {
                    title: '',
                    description: '',
                    status: '',
                    comments: '', 
                },
                {
                    title: '',
                    description: '',
                    status: '',
                    comments: '', 
                },
                {
                    title: '',
                    description: '',
                    status: '',
                    comments: '', 
                },
              
            ],

            SI_Personal: [
                {
                    title: '',
                    description: '',
                    status: '',
                    comments: '',
                   
                },
                {
                    title: '',
                    description: '',
                    status: '',
                    comments: '',
                   
                },
                {
                    title: '',
                    description: '',
                    status: '',
                    comments: '',
                   
                },
            ],

            issue_list_project: [
                {
                    short_terms_issue_1: '',
                    description_and_datetime_1: '',
                    short_terms_issue_2: '',
                    description_and_datetime_2: '',  
                },
                {
                    short_terms_issue_1: '',
                    description_and_datetime_1: '',
                    short_terms_issue_2: '',
                    description_and_datetime_2: '',  
                },
                {
                    short_terms_issue_1: '',
                    description_and_datetime_1: '',
                    short_terms_issue_2: '',
                    description_and_datetime_2: '',  
                },

                
            ],

            issue_list_personal: [
                {
                    short_terms_issue_1: '',
                    description_and_datetime_1: '',
                    short_terms_issue_2: '',
                    description_and_datetime_2: '',  
                },
                {
                    short_terms_issue_1: '',
                    description_and_datetime_1: '',
                    short_terms_issue_2: '',
                    description_and_datetime_2: '',  
                },
                {
                    short_terms_issue_1: '',
                    description_and_datetime_1: '',
                    short_terms_issue_2: '',
                    description_and_datetime_2: '',  
                },

                
            ],

            complate_task_project: [
                {
                    description: '',
                },
            ],

            complate_task_personal: [
                {
                    description: '',
                },
            ],     
        }
    },

    
}